import base64 from "base-64"
import { getCPRTokenEncryption, getFAFTokenEncryption, getTokenEncryption } from "./API/supertokenServices";
import { CPR_AK_VALUE, FAF_AK_VALUE, PARTNER_AK_VALUE } from "../constant/Constants";

export const akValue = async (data) => {
    const sData = data
    if (sData != "" && typeof sData[0] != "undefined") {
        let dcData = sData.slice(2);

        const number = Number(sData[1])
        const apData = sData[0].toUpperCase()

        const apDataToNumeric = apData.charCodeAt(0) - 64

        for (let i = 1; i <= apDataToNumeric; i++) {
            const decData = dcData.slice(0, number) + dcData.slice(number + 1)
            dcData = base64.decode(decData)
        }
        return dcData
    } else {
        let dataVal;
        if (PARTNER_AK_VALUE.value == "" || PARTNER_AK_VALUE.value == undefined || PARTNER_AK_VALUE.value == "--") {
            dataVal = await getTokenEncryption()
        } else if (CPR_AK_VALUE.value == "" || CPR_AK_VALUE.value == undefined || CPR_AK_VALUE.value == "--") {
            dataVal = await getCPRTokenEncryption()
        } else if (FAF_AK_VALUE.value == "" || FAF_AK_VALUE.value == undefined || FAF_AK_VALUE.value == "--") {
            dataVal = await getFAFTokenEncryption()
        }

        const sData = dataVal
        let dcData = sData.slice(2);

        const number = Number(sData[1])
        const apData = sData[0].toUpperCase()

        const apDataToNumeric = apData.charCodeAt(0) - 64

        for (let i = 1; i <= apDataToNumeric; i++) {
            const decData = dcData.slice(0, number) + dcData.slice(number + 1)
            dcData = base64.decode(decData)
        }
        return dcData
    }
}